// @flow

import { type UserInputValues } from '@tectonics/prs/user-input-values';
import { type OutgoingPayment } from '../outgoing-payment/types';

export function mexicanOutgoingPaymentMapper(userInputValues: UserInputValues): $Shape<OutgoingPayment> {
  return {
    country: 'mx',
    zipcode: userInputValues['mexicanZipcode'],
    state: userInputValues['mexicanState'],
    city: userInputValues['mexicanCity'],
    address: userInputValues['mexicanAddress'],
    street_number: userInputValues['mexicanStreetNumber'],
    street_complement: userInputValues['mexicanStreetComplement'],
    phone_number: userInputValues['mexicanPhoneNumber'],
  };
}
